import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { TotalPerYearFilter } from './total-per-year-filter.model';
import { IEntityFilters } from '../../entity-data/entity-data.data';

export const DOCUMENT_FILTERS_SCHEMA = Object.freeze({
  TOTAL_PER_YEARS: List<TotalPerYearFilter>([]),
});
const RECORD = generateSchema(DOCUMENT_FILTERS_SCHEMA);
const KEYS: any = generateKeys(DOCUMENT_FILTERS_SCHEMA);

export class DocumentFilters extends Record(RECORD) implements IEntityFilters {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TOTAL_PER_YEARS,
        value: props.get(KEYS.TOTAL_PER_YEARS)
          ? this.totalPerYearsFilter.map(
              (params) => new TotalPerYearFilter(params)
            )
          : List<TotalPerYearFilter>([]),
      },
    ]);

    return selfModel as DocumentFilters;
  }

  get totalPerYearsFilter(): List<TotalPerYearFilter> {
    return this.get(KEYS.TOTAL_PER_YEARS);
  }
}
